import dayjs from 'dayjs';
import { CreatePostOutput } from '@ametista-ai/api-schema/ai-client-types';
import { makeAutoObservable } from 'mobx';
import { v4 } from 'uuid';
import { UiStore } from '@/stores/ui';

export class CreatePostModalStore {
  opened = false;
  clientId?: string;
  date?: dayjs.Dayjs;
  chatId?: string;
  post?: CreatePostOutput;
  postVersion = 0;
  createMorePosts = false;

  constructor(public readonly uiStore: UiStore) {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  open(clientId?: string, date?: dayjs.Dayjs) {
    this.opened = true;
    this.clientId = clientId;
    this.date = date;
    this.chatId = v4();
  }

  openForChat(chatId: string, post?: CreatePostOutput) {
    this.opened = true;
    this.chatId = chatId;
    if (post) {
      this.fillPost(post);
    }
  }

  close() {
    this.opened = false;
  }

  setChatId(chatId: string) {
    this.chatId = chatId;
  }

  fillPost(post: CreatePostOutput) {
    this.post = post;
    if (post.clientId) {
      this.clientId = post.clientId;
    }
    this.bumpPostVersion();
  }

  setClientId(clientId: string) {
    this.clientId = clientId;
  }

  bumpPostVersion() {
    this.postVersion++;
  }

  reset(close = true) {
    if (close) {
      this.opened = false;
      this.postVersion = 0;
    }
    this.clientId = undefined;
    this.date = undefined;
    this.chatId = undefined;
    this.post = undefined;
  }

  setCreateMorePosts(createMorePosts: boolean) {
    this.createMorePosts = createMorePosts;
  }
}
